import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import './Badge.scss'

const Badge = ({ children, className, type }) => {
  const classNames = cx(
    'Badge',
    {
      'Badge--is-beta': type === 'beta',
      'Badge--is-new': type === 'new',
      'Badge--is-experimental': type === 'experimental',
    },
    className,
  )

  return <span className={classNames}>{children}</span>
}

Badge.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  type: PropTypes.oneOf(['beta', 'new', 'experimental']),
}

Badge.defaultProps = {
  type: 'beta',
}

export default Badge
